import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";
import { WishlistProvider } from "./components/WishlistContext";
import { AuthProvider } from "./lib/auth";

import Home from "./pages/Home";
import About from "./pages/About";
import Packages from "./pages/Packages";
import PackageDetail from "./pages/PackageDetail";
import Visa from "./pages/Visa";
import VisaDetail from "./pages/VisaDetail";
import Flights from "./pages/Flights";
import Cruise from "./pages/Cruise";
import Corporate from "./pages/Corporate";
import Honeymoon from "./pages/Honeymoon";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Layout({ children, hideChrome }) {
  return (
    <>
      {!hideChrome && <Header />}
      {children}
      {!hideChrome && <Footer />}
      {!hideChrome && <FloatingButtons />}
    </>
  );
}

function AppRoutes() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <Layout hideChrome={isAdmin}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/packages/:slug" element={<PackageDetail />} />
        <Route path="/visa" element={<Visa />} />
        <Route path="/visa/:slug" element={<VisaDetail />} />
        <Route path="/flights" element={<Flights />} />
        <Route path="/cruise" element={<Cruise />} />
        <Route path="/corporate" element={<Corporate />} />
        <Route path="/honeymoon" element={<Honeymoon />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <WishlistProvider>
          <BrowserRouter>
            <ScrollTop />
            <AppRoutes />
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </WishlistProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}
